import { GoogleLogin, GoogleLoginProps } from 'react-google-login'

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { GoogleOAuth } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<GoogleOAuth 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 />
 *```
 *
 *### Basic Example
 */

export const GoogleOAuth = (props: Props) =>  {

    const renderDefaultBtn = (renderProps: RendererProps) => (
        <button className="sbtn-icon" onClick={renderProps.onClick}>
            <img src="/assets/img/google.png" alt="google" />
        </button>
    )

    return (
        <GoogleLogin
            {...props}
            render={(renderProps) => (props.renderer?.(renderProps) || renderDefaultBtn(renderProps))}
            />
    )
}

type Props = GoogleLoginProps & {
    renderer?: (renderProps: RendererProps) => JSX.Element,
}

type RendererProps = { onClick: () => void, disabled?: boolean }
